import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import _ from 'lodash';

import {
	SortingState,
	IntegratedSorting,
	EditingState,
	IntegratedFiltering,
	FilteringState
} from '@devexpress/dx-react-grid';
import {
	Grid,
	VirtualTable,
	TableHeaderRow,
	TableEditRow,
	TableEditColumn,
	TableColumnResizing,
	TableFixedColumns, TableFilterRow,
} from '@devexpress/dx-react-grid-material-ui';


import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TableCell from '@material-ui/core/TableCell';
import Tooltip from '@material-ui/core/Tooltip';

import DeleteIcon from '@material-ui/icons/Delete';
import UndoIcon from '@material-ui/icons/Undo';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import SuggestSelect from '../input/suggest-select';


import {getValueHash, getValueArray, isSameObject} from '../../utils/array';
import {
	isEmpty,
	isNumLetter,
	isPassword,
	isUnique,
	getMessage,
	isDate,
	isNumLetterSymbol,
	isMailAddress,
	isNum
} from '../../utils/validation';
import Link from "@material-ui/core/Link";
import {
	FILTER_MESSAGE,
	getSuggestionFilteringColumnExtensionsForMaster,
	getSelectableFilteringColumnExtensionsForMaster,
	getSuggestionSortingExtensions,
	getColumnFilterDisabled,
	getColumnSortingDisabled,
	getRowId
} from "../../utils/tables";
import moment from "moment";
import {DatePicker} from "material-ui-pickers";

const styles = theme => ({
	tables: {
		'& tbody tr.isChange td': {
			backgroundColor: '#c4eaf1'
		},
		'& tbody tr.isAdd td': {
			backgroundColor: '#fffcf0'
		},
		'& tbody tr.isDelete td': {
			backgroundColor: '#dedede'
		},
	},
	EditCell: {
		paddingTop: theme.spacing.unit * 0.875,
		paddingRight: theme.spacing.unit,
		paddingLeft: theme.spacing.unit,
	},
	dialog: {
		width: 'calc(100% - 16px)',
	},
	inputRoot: {
		width: '100%',
	},
	textField: {
		width: '100%'
	},
	textFieldInput: {
		paddingTop: 8,
		paddingBottom: 8
	},
	lookupEditSelect: {
		paddingTop: 2,
		paddingBottom: 2
	},
	tooltips: {
		marginTop: 5,
		backgroundColor: 'rgba(255,0,0,0.9)',
	},
	tooltipsPoper: {
		zIndex: 5
	},
	clickableCell: {
		cursor: 'pointer'
	},
	datePicker: {
		width: 140
	},
});


const getColumnInfo = (columns) => {
	return columns.map((row) => {
		return {
			name: row.name,
			title: row.title,
			placeholder: (row.placeholder === undefined) ? '' : row.placeholder,
			maxLength: (row.maxLength === undefined) ? 5 : row.maxLength,
			disabled: (row.disabled === undefined) ? false : row.disabled,
			newDisabled: (row.newDisabled === undefined) ? false : row.newDisabled,
			defaultValue: !(row.defaultValue) ? null : row.defaultValue,
			validations: !(row.validations) ? [] : row.validations,
			uniqueSubKey: !(row.uniqueSubKey) ? null : row.uniqueSubKey,
			filteringEnabled: (row.filteringEnabled === undefined) ? true : row.filteringEnabled,
			sortingEnabled: (row.sortingEnabled === undefined) ? true : row.sortingEnabled,
		}
	})
};
const getColumnWidth = (columns) => {
	return columns.map((row) => {
		return {columnName: row.name, width: row.width}
	})
};
const getColumnDefaultValue = (columns, id) => {
	let returns = {};
	columns.forEach((row) => {
		returns[row.name] = row.defaultValue;
	});
	returns["id"] = id;
	return returns;

};

const validate = (data, rows, columns, is_new) => {
	let returns = {};
	Object.keys(rows).forEach((key) => {
		const row = rows[key];
		const error_rows = {};
		columns.forEach(column => {
			if (
				(column.validations.indexOf("required") >= 0 && isEmpty(row[column.name])) //必須
				||
				(is_new && column.validations.indexOf("new_required") >= 0 && isEmpty(row[column.name])) //追加時必須
			) {

				error_rows[column.name] = "required";
				return;
			}

			if (column.validations.indexOf("num") >= 0 && !isNum(row[column.name])) {
				error_rows[column.name] = "num";
				return;
			}

			if (column.validations.indexOf("numLetter") >= 0 && !isNumLetter(row[column.name])) {
				error_rows[column.name] = "numLetter";
				return;
			}

			if (column.validations.indexOf("numLetterSymbol") >= 0 && !isNumLetterSymbol(row[column.name])) {
				error_rows[column.name] = "numLetterSymbol";
				return;
			}

			if (column.validations.indexOf("password") >= 0 && !isPassword(row[column.name])) {
				error_rows[column.name] = "password";
			}

			if (column.validations.indexOf("dateFormat") >= 0 && !isDate(row[column.name])) {
				error_rows[column.name] = "dateFormat";
			}

			if (column.validations.indexOf("mailAddress") >= 0 && !isMailAddress(row[column.name])) {
				error_rows[column.name] = "mailAddress";
			}

			if (is_new && column.validations.indexOf("unique") >= 0 && !isUnique(data, row, column.name, column.uniqueSubKey)) {
				error_rows[column.name] = "unique";
			}

		});
		if (Object.keys(error_rows).length) {
			returns[key] = error_rows;
		}
	});
	return returns;
};


class masterTable extends Component {
	constructor(props) {
		super(props);
		this.state = {
			rows: props.dataSource,
			columns: getColumnInfo(props.columns),
			defaultColumnWidths: getColumnWidth(props.columns),
			editingRowIds: [],
			addedRows: [],
			rowChanges: {},
			errors: {},
			leftFixedColumns: [TableEditColumn.COLUMN_TYPE],
			filters: [],
			sorts: props.defaultSorts
		};

		const getStateRows = () => {
			const {rows} = this.state;
			return rows;
		};


		this.changeEditingRowIds = editingRowIds => {
			const current = editingRowIds.find(row => (!this.state.editingRowIds.includes(row)));
			if (current !== undefined) {
				const errors = this.state.errors;
				delete errors[current];
				this.setState({errors})
			}
			this.setState({editingRowIds});
		};
		this.changeAddedRows = _.debounce(addedRows => {
			const addRowLength = _.filter(this.state.rows, {isAdd: true}).length;
			const startingAddedId = (addRowLength === 0) ? -1 : (addRowLength * -1) - 1;
			const addRow = addedRows.map(row => {
				return (Object.keys(row).length ? row : {
					...getColumnDefaultValue(this.props.columns, startingAddedId),
					isNew: true
				})
			});

			let checkRow = {};
			let def_errors = getValueHash(this.state.errors);
			let rows = getValueArray(this.state.rows);
			addRow.forEach(row => {
				checkRow[row["id"]] = row;
				delete def_errors[row["id"]];
			});
			const errors = Object.assign(def_errors, validate(rows, checkRow, this.state.columns, true));
			this.setState({
				addedRows: addRow,
				errors
			});
		}, 250);
		this.changeRowChanges = _.debounce(rowChanges => {
			let checkRow = {};
			let def_errors = getValueHash(this.state.errors);
			let rows = getValueArray(this.state.rows);
			Object.keys(rowChanges).forEach(id => {
				checkRow[id] = Object.assign(getValueHash(_.filter(rows, {id: parseInt(id, 10)}).shift()), rowChanges[id]);
				delete def_errors[id];
			});
			const errors = Object.assign(def_errors, validate(rows, checkRow, this.state.columns, false));
			this.setState({errors, rowChanges});
		}, 250);
		this.commitChanges = ({added, changed, deleted}) => {
			let {rows} = this.state;

			if (added) {
				rows = [
					...rows,
					...added.map((row, index) => ({
						isAdd: true,
						...row,
					})),
				];
			}
			if (changed) {
				rows = rows.map(
					row => {
						return changed[row.id]
							? {...row, ...changed[row.id], isChange: !(row.isAdd)}
							: row
					});
			}
			if (deleted) {
				let deleteRow = this.deleteNewRows(deleted);
				rows = deleteRow.map(row => (
					deleted.indexOf(row.id) >= 0
						? row.DelFlag === "1"
							? {...row, isDelete: !row.isDelete, isUpdateDelete: row.isDelete}
							: {...row, isDelete: !row.isDelete, isUpdateDelete: !row.isDelete}
						: row
				));
			}
			this.setState({rows});
		};
		this.deleteNewRows = (deletedIds) => {
			const rows = getStateRows().slice();
			deletedIds.forEach((rowId) => {
				const index = rows.findIndex(row => row.id === rowId);
				if (index > -1 && rows[index]["isAdd"]) {
					rows.splice(index, 1);
				}
			});
			return rows;
		};
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.dataSource !== this.props.dataSource) {
			this.setState({
				rows: nextProps.dataSource,
				editingRowIds: [],
				addedRows: [],
				rowChanges: {},
				errors: {},
				filters: [],
				sorts: nextProps.defaultSorts
			})
		}
	}

	UNSAFE_componentWillUpdate(nextProps, nextState, nextContext) {
		const {rows, addedRows, editingRowIds} = nextState;

		if (!isSameObject(rows, this.state.rows) || !isSameObject(addedRows, this.state.addedRows) || !isSameObject(editingRowIds, this.state.editingRowIds)) {
			if (nextProps.getCurrentState) nextProps.getCurrentState({rows, addedRows, editRows: editingRowIds});
		}

	}

	TableComponentBase = ({classes, ...restProps}) => (
		<VirtualTable.Table
			{...restProps}
			className={classes.tables}
		/>
	);
	TableComponent = withStyles(styles, {name: 'ControlledModeDemo'})(this.TableComponentBase);

	RowComponent = ({...props}) => {
		const className = (props.row.isDelete) ? "isDelete" : (props.row.isAdd) ? "isAdd" : (props.row.isChange) ? "isChange" : '';
		return (
			<VirtualTable.Row {...props}
							  className={className}
			/>
		);
	};

	EditButton = ({onExecute}) => {
		return (
			<IconButton onClick={onExecute} title="編集">
				<EditIcon/>
			</IconButton>
		)
	};

	DeleteButton = ({onExecute}) => (
		<IconButton onClick={onExecute} title="削除">
			<DeleteIcon/>
		</IconButton>
	);
	UndoButton = ({onExecute}) => (
		<IconButton onClick={onExecute} title="戻す">
			<UndoIcon/>
		</IconButton>
	);

	CommitButton = ({onExecute, row, errors}) => {
		const handleExecute = () => {
			onExecute();
		};
		const disabled = (errors[getRowId(row)] !== undefined);
		return (
			<IconButton disabled={disabled} color="primary" onClick={handleExecute} title="確定">
				<SaveIcon/>
			</IconButton>
		);
	};

	CancelButton = ({onExecute}) => {
		return (
			<IconButton onClick={onExecute} title="取消">
				<CancelIcon/>
			</IconButton>
		)
	};

	commandComponents = {
		edit: this.EditButton,
		delete: this.DeleteButton,
		undo: this.UndoButton,
		commit: this.CommitButton,
		cancel: this.CancelButton,
	};


	EditCommand = ({errors, ...props}) => {
		const isDeleted = props.row.isDelete;
		return (
			<TableEditColumn.Cell {...props}>
				{props.children.map((child, index) => {
					if (child && child.props.id) {
						let CommandButton = this.commandComponents[child.props.id];
						if (isDeleted) {
							if (child.props.id === "edit") return null;
							if (child.props.id === "delete") {
								CommandButton = this.commandComponents["undo"];
								return <CommandButton
									key={index}
									onExecute={child.props.onExecute}
									row={props.row}
									errors={errors}
								/>;
							}
							return <CommandButton
								key={index}
								onExecute={child.props.onExecute}
								row={props.row}
								errors={errors}
							/>;
						} else {
							return <CommandButton
								key={index}
								onExecute={child.props.onExecute}
								row={props.row}
								errors={errors}
							/>;
						}
					} else {
						return child;
					}
				})}
			</TableEditColumn.Cell>
		);
	};

	LookupEditCellBase = ({disabled, availableColumnValues, value, onValueChange, classes,}) => (
		<TableCell
			className={classes.EditCell}
		>
			<Select
				value={value}
				onChange={event => onValueChange(event.target.value)}
				className={classes.lookupEditSelect}
				input={(
					<Input
						classes={{root: classes.inputRoot}}
					/>
				)}
			>
				{availableColumnValues.map(item => {
					if (item.disabled) return null;
					return (
						<MenuItem key={item.value} value={item.value}>
							{item.name}
						</MenuItem>
					)

				})}
			</Select>
		</TableCell>
	);
	LookupEditCell = withStyles(styles, {name: 'LookupEditCell'})(this.LookupEditCellBase);


	LookupCellBase = ({availableColumnValues, props}) => {
		const values = _.filter(availableColumnValues, {value: props.value}).shift();
		const label = (values === undefined) ? "" : values.name;
		return (
			<VirtualTable.Cell {...props}>
				{label}
			</VirtualTable.Cell>
		);
	};
	LookupCell = withStyles(styles, {name: 'LookupCell'})(this.LookupCellBase);

	SuggestionEditCellBase = ({rowError, error, disabled, suggestions, ...props}) => {
		const {classes, column, onValueChange, value} = props;
		const handleChange = (event) => {
			onValueChange(event);
		};
		const errorMassage = !(rowError) ? "" : getMessage(rowError[column.name]);
		return (
			<TableCell
				className={classes.EditCell}
			>
				<Tooltip
					placement="bottom-start" open={error}
					classes={{tooltip: classes.tooltips, popper: classes.tooltipsPoper}} title={errorMassage}>
					<SuggestSelect
						suggestions={suggestions}
						afterChangeFunction={handleChange}
						maxLength={column.maxLength}
						fixValue={column.defaultValue}
						defaultValue={value}
						error={error}
						disabled={disabled}
						maxMenuHeight={192}
						forTable={true}
					/>
				</Tooltip>
			</TableCell>

		);
	};
	SuggestionEditCell = withStyles(styles, {name: 'SuggestionEditCell'})(this.SuggestionEditCellBase);


	SuggestionCellBase = ({suggestions, props}) => {
		const {value, column} = props;
		let values = "";
		if (value) {
			values = (column.defaultValue === null) ? value.label : column.defaultValue.label;
		}
		return (
			<VirtualTable.Cell>
				{values}
			</VirtualTable.Cell>
		);
	};
	SuggestionCell = withStyles(styles, {name: 'SuggestionCell'})(this.SuggestionCellBase);

	ClickableCellBase = ({classes, clickOption, props}) => {
		return (
			<VirtualTable.Cell>
				<Link
					onClick={() => {
						clickOption.onClick(props.row)
					}}
					className={classes.clickableCell}
				>
					{clickOption.text}
				</Link>
			</VirtualTable.Cell>
		);
	};
	ClickableCell = withStyles(styles, {name: 'ClickableCell'})(this.ClickableCellBase);

	ViewCellBase = ({classes, ...props}) => {
		const {value} = props;
		return (
			<VirtualTable.Cell>
				<p
				>
					{value}
				</p>
			</VirtualTable.Cell>
		);
	};
	ViewCell = withStyles(styles, {name: 'ViewCell'})(this.ViewCellBase);

	DateCellBase = ({rowError, error, disabled, ...props}) => {
		const {classes, column, onValueChange, value} = props;
		const errorMassage = !(rowError) ? "" : getMessage(rowError[column.name]);
		const onDateChange = date => {
			onValueChange(date.format('YYYY/MM/DD'));
		};
		const onInputDateChange = event => {
			onValueChange((event.target.value) === "" ? null : event.target.value);
		}

		const dateValue = error || value === null ? null : moment(value);
		return (
			<TableCell
				className={classes.EditCell}
			>
				<Tooltip placement="bottom-start" open={error}
						 classes={{tooltip: classes.tooltips, popper: classes.tooltipsPoper}} title={errorMassage}>
					<DatePicker
						keyboard
						value={dateValue}
						onChange={onDateChange}
						onInputChange={onInputDateChange}
						format="YYYY/MM/DD"
						cancelLabel={"キャンセル"}
						invalidDateMessage={null}
						minDateMessage={null}
						maxDateMessage={null}
						error={error}
						className={classes.datePicker}
					/>
				</Tooltip>
			</TableCell>
		);
	};
	DateCell = withStyles(styles, {name: 'DateCell'})(this.DateCellBase);


	EditCellBase = ({rowError, error, disabled, ...props}) => {
		const {classes, column, onValueChange, value, row} = props;
		const placeholder = (row.isNew) ? column.newPlaceholder : column.placeholder;
		const errorMassage = !(rowError) ? "" : getMessage(rowError[column.name]);
		return (
			<TableCell
				className={classes.EditCell}
			>
				<Tooltip placement="bottom-start" open={error}
						 classes={{tooltip: classes.tooltips, popper: classes.tooltipsPoper}} title={errorMassage}>
					<Input
						defaultValue={value}
						onChange={event => onValueChange(event.target.value)}
						className={classes.textField}
						fullWidth
						placeholder={placeholder}
						inputProps={{
							className: classes.textFieldInput,
							maxLength: column.maxLength,
						}}
						disabled={disabled}
						error={error}
					/>
				</Tooltip>
			</TableCell>
		);
	};
	EditCell = withStyles(styles, {name: 'ControlledModeDemo'})(this.EditCellBase);


	CellComponent = (props) => {

		const {column} = props;
		const {selectableColumns, suggestionColumns, clickableColumns, viewColumns} = this.props;
		if (selectableColumns[column.name]) {
			return <this.LookupCell props={props} availableColumnValues={selectableColumns[column.name]}/>;
		}
		if (suggestionColumns[column.name]) {
			return <this.SuggestionCell props={props} suggestions={suggestionColumns[column.name]}/>;
		}
		if (clickableColumns[column.name]) {
			return <this.ClickableCell props={props} clickOption={clickableColumns[column.name]}/>;
		}
		if (viewColumns.includes(column.name)) {
			return <this.ViewCell{...props} />;
		}

		return <VirtualTable.Cell {...props} />;
	};

	EditCellComponent = (props) => {
		const {column, row} = props;
		const {selectableColumns, suggestionColumns, clickableColumns, dateColumns, viewColumns} = this.props;

		const disabled = (row.id < 0 && !(row.isAdd)) ? column.newDisabled : column.disabled;
		const row_error = this.state.errors[getRowId(props.row)];
		const error = (row_error) ? (row_error[column.name] !== undefined) : false;

		if (selectableColumns[column.name]) {
			return <this.LookupEditCell {...props} availableColumnValues={selectableColumns[column.name]}
										rowError={row_error} error={error} disabled={disabled}/>;
		}
		if (suggestionColumns[column.name]) {
			return <this.SuggestionEditCell {...props} suggestions={suggestionColumns[column.name]} rowError={row_error}
											error={error} disabled={disabled}/>;
		}
		if (clickableColumns[column.name]) {
			return <this.ClickableCell props={props} clickOption={clickableColumns[column.name]}/>;
		}
		if (dateColumns.includes(column.name)) {
			return <this.DateCell {...props} rowError={row_error} error={error} disabled={disabled}/>;
		}
		if (viewColumns.includes(column.name)) {
			return <this.ViewCell{...props} />;
		}
		return <this.EditCell rowError={row_error} error={error} disabled={disabled} {...props} />;
	};

	handleFiltersChange = (filters) => {
		this.setState({filters});
	}
	handleSortingChange = (sorts) => {
		this.setState({sorts});
	}


	render() {
		const {
			rows,
			columns,
			defaultColumnWidths,
			editingRowIds,
			rowChanges,
			addedRows,
			errors,
			leftFixedColumns,
			filters,
			sorts
		} = this.state;
		const {suggestionColumns, selectableColumns, navigation} = this.props;
		const height = (navigation.windowHeight) - 300;


		const suggestionFilterColumnExtensions = getSuggestionFilteringColumnExtensionsForMaster(suggestionColumns);
		const selectableFilteringColumnExtensions = getSelectableFilteringColumnExtensionsForMaster(selectableColumns)
		const filteringColumnExtensions = suggestionFilterColumnExtensions.concat(selectableFilteringColumnExtensions);

		const filterEnables = getColumnFilterDisabled(columns);
		const sortEnables = getColumnSortingDisabled(columns);

		const customSorting = getSuggestionSortingExtensions(suggestionColumns);

		return (
			<Grid
				rows={rows}
				columns={columns}
				getRowId={getRowId}
			>
				<SortingState
					columnExtensions={sortEnables}
					onSortingChange={this.handleSortingChange}
					sorting={sorts}
				/>
				<FilteringState
					columnExtensions={filterEnables}
					onFiltersChange={this.handleFiltersChange}
					filters={filters}
				/>
				<EditingState
					editingRowIds={editingRowIds}
					onEditingRowIdsChange={this.changeEditingRowIds}
					rowChanges={rowChanges}
					onRowChangesChange={this.changeRowChanges}
					addedRows={addedRows}
					onAddedRowsChange={this.changeAddedRows}
					onCommitChanges={this.commitChanges}
				/>

				<IntegratedSorting
					columnExtensions={customSorting}
				/>
				<IntegratedFiltering
					columnExtensions={filteringColumnExtensions}
				/>
				<VirtualTable
					height={height}
					tableComponent={this.TableComponent}
					rowComponent={this.RowComponent}
					cellComponent={this.CellComponent}

				/>
				<TableColumnResizing defaultColumnWidths={defaultColumnWidths}/>
				<TableHeaderRow
					showSortingControls={true}
				/>
				<TableFilterRow
					showFilterSelector={true}
					messages={FILTER_MESSAGE}
				/>
				<TableEditRow
					cellComponent={this.EditCellComponent}
				/>
				<TableEditColumn
					showAddCommand={!addedRows.length}
					showEditCommand
					showDeleteCommand
					cellComponent={props => <this.EditCommand {...props} errors={errors}/>}
					messages={{addCommand: '追加'}}
				/>
				<TableFixedColumns
					leftColumns={leftFixedColumns}
				/>
			</Grid>
		);
	}
}

masterTable.propTypes = {
	dataSource: PropTypes.array,
	columns: PropTypes.array,
	selectableColumns: PropTypes.object,
	suggestionColumns: PropTypes.object,
	clickableColumns: PropTypes.object,
	viewColumns: PropTypes.array,
	dateColumns: PropTypes.array,
	defaultSorts: PropTypes.array,
	getCurrentState: PropTypes.func,

};
masterTable.defaultProps = {
	dataSource: [],
	columns: [],
	selectableColumns: {},
	suggestionColumns: {},
	clickableColumns: {},
	dateColumns: [],
	viewColumns: [],
	defaultSorts: [],
};

function mapStateToProps(state) {
	return {
		auth: state.auth,
		navigation: state.navigation
	};
}

export default connect(mapStateToProps)(masterTable);



// WEBPACK FOOTER //
// ./src/common/components/table/master-table.js